import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";

import CryptoChartSection from "../CryptoChart";
import AccountTypes from "../About/AccountTypes";

const Prices = () => {
  return (
    <div className="main-section">
      {/* This section displays the cryptocurrency dashboard with charts and tables */}
      <Container fluid className="section">
        <Row className="justify-content-center text-center">
          <Col md={8} lg={5}>
            <motion.div
              className="section-header p-0"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <h3>Account Types</h3>
              <h4 className="text-center mt-4">Under Retail</h4>
            </motion.div>
          </Col>
        </Row>
        {/* This section displays the cryptocurrency dashboard with charts and tables */}

        {/* <TableSection /> */}
        <AccountTypes />

        {/* This section displays the cryptocurrency  charts  */}
        <motion.div
          className=" my-5"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <Row className="justify-content-center">
            <Col xs={12} md={10} xl={9}>
              <Row className="g-4">
                <Col xs={12} sm={12} lg={12} xl={12}>
                  <div className="chart-wrapper px-2 rounded shadow-sm">
                    <CryptoChartSection />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </motion.div>
      </Container>
    </div>
  );
};

export default Prices;
